<template>
  <div class="platform-member">
    <!--头部-->
    <!--<van-nav-bar class="member-header" title="会员管理" left-arrow @click-left="onClickLeft" :border="false"/>-->
    <div class="header">
      <div class="title">当前身份：{{ memberGrade.memberName }}</div>
      <div class="icon" @click="goRules"></div>
    </div>

    <div class="bg-10px"></div>

    <p class="title">平台现金奖励收益</p>
    <div class="money-con">
      <div class="flex-item">
        <p class="text">今日奖金(元)</p>
        <p class="num">{{ earn.todayCashAmount | filter2 }}</p>
      </div>
      <div class="gray-line"></div>
      <div class="flex-item">
        <p class="text">待结算(元)</p>
        <p class="num">{{ earn.waitSettleCashAmount | filter2 }}</p>
      </div>
      <div class="gray-line"></div>
      <div class="flex-item">
        <p class="text">已提现(元)</p>
        <p class="num">{{ withdrawal | filter2 }}</p>
      </div>
    </div>
    <div class="money-con">
      <div class="flex-item">
        <p class="text">本月奖金累计(元)</p>
        <p class="num">{{ earn.monthCashAmount | filter2 }}</p>
      </div>
      <div class="gray-line"></div>
      <div class="flex-item">
        <p class="text">奖金累计总额(元)</p>
        <p class="num">{{ earn.totalCashAmount | filter2 }}</p>
      </div>
    </div>

    <div class="bg-10px"></div>

    <p class="title">平台会员管理</p>
    <div class="tool-bottom">
      <div class="tool-con">
        <div class="flex-item" @click="goSubordinate">
          <div class="img-con">
            <img class="img" src="../../../../assets/my/member/member-icon1.png" alt="">
          </div>
          <div class="text-con">
            <p class="text">直推用户</p>
            <p class="num"><span>{{ memberGrade.childrenCntLevel1 }}</span> 人</p>
          </div>
        </div>
        <div class="gray-line"></div>
        <div class="flex-item" @click="goSubordinate">
          <div class="img-con">
            <img class="img" src="../../../../assets/my/member/member-icon1.png" alt="">
          </div>
          <div class="text-con">
            <p class="text">间推用户</p>
            <p class="num"><span>{{ memberGrade.childrenCntLevel2 }}</span> 人</p>
          </div>
        </div>
      </div>
      <div class="tool-con">
        <div class="flex-item" @click="goStatistics">
          <div class="img-con">
            <img class="img" src="../../../../assets/my/member/member-icon2.png" alt="">
          </div>
          <div class="text-con">
            <p class="text">推荐用户统计</p>
            <p class="num"><span>{{ (memberGrade.childrenCntLevel1-0) + (memberGrade.childrenCntLevel2-0) }}</span> 人</p>
          </div>
        </div>
        <div class="gray-line"></div>
        <div class="flex-item" @click="goMemberReward">
          <div class="img-con">
            <img class="img" src="../../../../assets/my/member/member-icon3.png" alt="">
          </div>
          <div class="text-con">
            <p class="text">现金奖金明细</p>
            <p class="num"><span>{{ earn.totalCnt || 0 }}</span> 条</p>
          </div>
        </div>

<!--        <div class="flex-item" @click="goMemberRewardCoin">
          <div class="img-con">
            <img class="img" src="../../../../assets/my/member/member-icon5.png" alt="">
          </div>
          <div class="text-con">
            <p class="text">金币奖励明细</p>
            <p class="num"><span>{{ coinTotalCount }}</span> 条</p>
          </div>
        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
import { getUserEarnStat, getMemberEarnLogs } from '@/api/mall/mallSettle'
import { memberPlatformGrade, memberPlatformGradeV2, } from '@/api/member'
import { getCashWallet } from '@/api/wallet/cash'
import { totalWithdrawal } from '@/api/pay/payApi'
export default {
  components: {
  },
  data () {
    return {
      userOpenId: this.session('userOpenId'),
      memberGrade: {},


      //奖励明细
      earn: {
        monthCashAmount: 0, // 本月奖金--现金 ,
        // monthIntegralAmount: 0, // 本月奖金--金币
        todayCashAmount: 0, // 今日奖金--现金 ,
        // todayIntegralAmount: 0, // 今日资金--金币
        totalCashAmount: 0, // 累计奖金--现金 ,
        // totalCnt: 0, // 奖金明细总记录数
        // totalIntegralAmount: 0, // 累计奖金--金币 ,
        waitSettleCashAmount: 0, // 待结算奖金--现金
        // waitSettleIntegralAmount: 0 // 待结算奖金--金币
      },
      withdrawal: 0, // 提现金额
      coinTotalCount: 0,
    }
  },
  computed: {

  },
  created(){
    this.getPlatformMemberEarn()
    this.getWithdrawal()
    this.getMemberPlatformGrade()
    this.getMemberEarnLogs()
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1)
    },
    goSubordinate() {
      // this.$router.push({name: 'platformSubordinate'})
    },
    goStatistics() {
      this.$router.push({name: 'platformStatistics'})
    },
    goMemberReward() {
      this.$router.push({name: 'platformReward'})
    },
    // goMemberRewardCoin() {
    //   this.$router.push({name: 'platformRewardCoin'})
    // },
    goRules() {
      this.$router.push({name: 'membershipRules'})
    },


    // 获取 平台+店铺 的汇总奖励
    getPlatformMemberEarn(){
      getUserEarnStat({earnTypes: ['PLATFORM_MEMBER']}).then(res=>{
        this.earn = res.data
      })
    },
    getWithdrawal(){
      // 获取个人现金钱包地址
      getCashWallet({userOpenid: this.session('userOpenId'), walletType:0}).then(res=>{
        let account = res.data.account
        //获取提现总金额
        totalWithdrawal({walletAccount: account}).then(res=>{
          this.withdrawal = res.data || 0;
        })
      })
    },

    // 获取个人的平台会员等级
    getMemberPlatformGrade(){
      memberPlatformGradeV2().then(res=>{
        this.memberGrade = res.data || {}
      })
    },

    //获取奖励条数
    getMemberEarnLogs(){
      getMemberEarnLogs({
        tabs: 'SETTLED',
        earnTypeSubList: ['PLATFORM_AGENT']+'',//数组转成字符串
        currencyType: 'GOLD_COIN',
        memberType: 'PLATFORM',
        targetId: this.session('userOpenId'), // 收益者ID，个人及服务钱包是userOpenid，如果是店铺钱包则是shopid，组织钱包时为组织ID
        targetType: 0, // 收益者类型：0-个人；1-店铺；2-服务（代理商）；4：组织（多个时使用逗号分隔）；5：个人+服务（代理商）
        page: 1,
        size: 1
      }).then(res => {
        this.coinTotalCount = res.data.totalCount || 0
      })
    },

  }
}
</script>

<style scoped lang="less">
@img: '../../../../assets/my/member/';
.platform-member{
  .member-header{
    background-color: transparent;
    position: absolute;
    z-index: 9;
    width: 100%;
    .van-nav-bar__left{
      .van-icon{
        color: #fff !important;
      }
    }
    .van-nav-bar__title{
      color: #fff;
    }
  }
  .header{
    display: flex;justify-content: flex-end;align-items: center;
    height: 44px;border-bottom: 1px solid #edecec;
    .title{flex: 1;}
    .icon{
      display: inline-flex;width: 42px;height: 100%;
      background: url("../../../../assets/my/member/rules-icon.png") no-repeat 50% 50%;
      background-size: 18px 18px;
    }
  }

  .title{
    line-height: 44px;
    padding: 0 12px;
    font-size: 16px;
    font-weight: bold;
    border-bottom: 1px solid #edecec;
  }
  .money-con{
    display: flex;
    height: 74px;
    border-bottom: 1px solid #edecec;
    .flex-item{
      flex: 1;
      display: inline-flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .text{
        font-size: 12px;
        padding-bottom: 4px;
      }
      .num{
        font-size: 16px;font-weight: 600;
      }
    }
    .gray-line{
      width: 1px;
      background: #ddd;
      margin: 16px 0;
    }
  }


  .platform-member-identity{
    overflow: hidden;width: 100%;height: 82px;
    .scroll-x{
      padding: 5px 12px;overflow-y: hidden;overflow-x: auto;white-space: nowrap;
      display: flex;justify-content: space-between;
      .item{
        display: inline-flex;flex-direction: column;min-width: 58px;max-width: 58px;margin-bottom: 10px;
        .icon-con{
          display: flex;justify-content: center;align-items: center;
          width: 100%;height: 52px;
          .icon{
            width: 27px;height: 40px;
            background-color: #f0ad4e;
          }
          each(range(3), {
            .icon-@{value}{
              background: url("@{img}platform-member-@{value}.png") no-repeat 50% 50%;background-size: 100%;
              //&.active{background: url("@{img}platform-member-@{value}-active.png") no-repeat 50% 50%;background-size: 100%;}
            }
          });
        }
        .text{
          overflow: hidden;text-overflow:ellipsis;white-space: nowrap;
          padding-bottom: 5px;line-height: 12px;
          text-align: center;font-size: 12px;color: #333;
        }
      }
      .arrow-item{
        display: inline-flex;flex-direction: column;min-width: 22px;max-width: 22px;margin-bottom: 10px;
        .icon-con{
          display: flex;justify-content: center;align-items: center;
          width: 100%;height: 52px;
          .icon{
            width: 22px;height: 11px;
            background: url("@{img}arrow.png") no-repeat 50% 50%;background-size: 100%;
            &.active{background: url("@{img}arrow-blue.png") no-repeat 50% 50%;background-size: 100%;}
          }
        }
        .text{padding-bottom: 5px;line-height: 12px;font-size: 12px;text-align: center;color: #333;}
      }
    }
  }

  .tool-bottom{
    .tool-con{
      display: flex;
      border-bottom: 1px solid #edecec;
      .flex-item{
        display: inline-flex;
        flex: 1;
        height: 74px;
        align-items: center;
        justify-content: center;
        color: #1e1e1e;
        padding-left: 10px;
        .img-con{
          display: inline-flex;justify-content: center;align-items: center;
          width: 70px;height: 100%;
          .img{
            display: block;
            width: 46px;
            height: 46px;
          }
        }

        .text-con{
          flex: 1;
          .text{
            width: 100%;
            font-size: 14px;
          }
          .num{
            font-size: 12px;
            color: #999;
          }
        }

      }
      .gray-line{
        width: 1px;
        background: #ddd;
        margin: 16px 0;
      }
    }
  }
}
</style>
<style lang="less">
.platform-member{

}
</style>
